import { z } from "zod";

import { ColumnKey, SortableColumnKey } from "./-hooks/useColumns";

const Unknown = ["ONLY", "INCLUDE", "EXCLUDE"] as const;

export const SearchSchema = z.object({
  freeText: z.string().optional(),
  shadowItAppIdIn: z.array(z.string()).optional(),
  visitedFrom: z.string().optional(),
  visitedTo: z.string().optional(),
  unknown: z.enum(Unknown).optional(),

  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  sortColumn: z.enum(SortableColumnKey).default(ColumnKey.visitedAt),
  sortOrder: z.enum(["asc", "desc"]).default("desc"),
});

export type SearchParams = z.infer<typeof SearchSchema>;
